// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-quantity-input[data-v-11bce4f6]{max-width:175px}.unit-quantity-input[data-v-11bce4f6]{min-width:44px;text-align:center}", ""]);
// Exports
module.exports = exports;
